import { useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import { RecommendationsPage } from '@practium/features/recommendations';
import type { RecommendationsTab } from '@practium/features/recommendations';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';
import { isRecommendationsTab } from '../routes';

export const RecommendationsPageClient = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();

	const tabParam = searchParams.get('tab');
	const initialTab: RecommendationsTab = isRecommendationsTab(tabParam) ? tabParam : 'correction';

	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';
	const canRead = abilities.can('read', subject);
	const permissions = {
		canCreate: abilities.can('create', subject),
		canEdit: abilities.can('update', subject),
		canDelete: abilities.can('delete', subject),
	};

	const handleAddNew = (tab: RecommendationsTab) => {
		if (tab === 'foliar') navigate('/recomendacoes/foliares/novo');
		else if (tab === 'maintenance') navigate('/recomendacoes/manutencao/novo');
		else navigate('/recomendacoes/correcao/novo');
	};

	const handleViewItem = (tab: RecommendationsTab, id: string) => {
		if (tab === 'foliar') navigate(`/recomendacoes/foliares/ver?id=${id}`);
		else if (tab === 'maintenance') navigate(`/recomendacoes/manutencao/workspace?id=${id}`);
		else navigate(`/recomendacoes/correcao/workspace?id=${id}`);
	};

	const handleTabChange = (tab: RecommendationsTab) => setSearchParams({ tab }, { replace: true });

	if (!canRead) return <Navigate to="/" replace />;

	return (
		<RecommendationsPage
			permissions={permissions}
			initialTab={initialTab}
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
			onTabChange={handleTabChange}
		/>
	);
};
